<template>
  <b-container class="pl-0 pr-0 pt-0 pb-0 border-bottom border-top">
    <b-row class="text-left">
      <b-col>
        <b-form-group 
          id="specificgroup"
          breakpoint="md"
          label="Specific"
          label-for="specific"
          horizontal
          validated
        >
          <wysiwyg v-model="specific" id="specific"/>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row class="text-left">
      <b-col>
        <b-form-group 
          id="measuresGroup"
          breakpoint="md"
          label="Measures"
          label-for="measures"
          horizontal
          validated
        >
          <wysiwyg v-model="measures" id="measures"/>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row class="text-left">
      <b-col>
        <b-form-group 
          id="actiongroup"
          breakpoint="md"
          label="Action"
          label-for="action"
          horizontal
          validated
        >
          <wysiwyg v-model="action" id="action"/>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row class="text-left">
      <b-col>
        <b-form-group 
          id="relevancegroup"
          breakpoint="md"
          label="Relevance"
          label-for="relevance"
          horizontal
          validated
        >
          <wysiwyg v-model="relevance" id="relevance"/>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row class="text-left">
      <b-col>
        <b-form-group 
          id="timegroup"
          breakpoint="md"
          label="Time"
          label-for="time"
          horizontal
          validated
        >
          <wysiwyg v-model="time" id="time"/>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row class="text-right">
      <b-col>
        <vue-confirmation-button :css="'btn btn-danger sm'" :messages="['Delete S.M.A.R.T Goal (not entire session)','Are you sure?','Deleted']" @confirmation-success="deleteItem();"/>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>

import vueConfirmationButton from 'vue-confirmation-button';

export default {
  name: 'Goal',
  // properties you can pass to this component
  props: ['goal'],
  components: {
    vueConfirmationButton
  },
  watch: {
    specific: {
      handler(newData) {
        this.goal.s = newData;
        this.sendUpdate();
      }
    },
    measures: {
      handler(newData) {
        this.goal.m = newData;
        this.sendUpdate();
      }
    },
    action: {
      handler(newData) {
        this.goal.a = newData;
        this.sendUpdate();
      }
    },
    relevance: {
      handler(newData) {
        this.goal.r = newData;
        this.sendUpdate();
      }
    },
    time: {
      handler(newData) {
        this.goal.t = newData;
        this.sendUpdate();
      }
    } 
  },
  // this is reactive data and will be updated in the view
  data () {
    return {
      specific: '',
      measures: '',
      action: '',
      relevance: '',
      time: '',
      is_deleted: 0
    };
  },
  created () {
    this.specific = this.goal.s;
    this.measures = this.goal.m;
    this.action = this.goal.a;
    this.relevance = this.goal.r;
    this.time = this.goal.t;
    this.is_deleted = this.goal.is_deleted
  },
  methods: {
    sendUpdate() {
      this.$emit('input', this.goal);
    },
    deleteItem() {
      this.is_deleted = 1;
      this.goal.is_deleted = 1;
      this.sendUpdate();
    }
  }  
}
</script>


// WEBPACK FOOTER //
// src/components/Goal.vue